/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_View_ChartInputs */

const en_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart`)
};

const fr_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graphique`)
};

const de_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagramm`)
};

const it_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafico`)
};

const ru_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диаграмма`)
};

const es_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuadro`)
};

const zh_cn2_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图表`)
};

const ja_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャート`)
};

const hi_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चार्ट`)
};

const pt_pt2_usage_view_chart = /** @type {(inputs: Usage_View_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráfico`)
};

/**
* | output |
* | --- |
* | "Chart" |
*
* @param {Usage_View_ChartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_view_chart = /** @type {((inputs?: Usage_View_ChartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_View_ChartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_view_chart(inputs)
	if (locale === "de") return de_usage_view_chart(inputs)
	if (locale === "it") return it_usage_view_chart(inputs)
	if (locale === "ru") return ru_usage_view_chart(inputs)
	if (locale === "es") return es_usage_view_chart(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_view_chart(inputs)
	if (locale === "ja") return ja_usage_view_chart(inputs)
	if (locale === "hi") return hi_usage_view_chart(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_view_chart(inputs)
	return en_usage_view_chart(inputs)
});